<template>
  <div>
    <div class="d-flex justify-space-between align-center">
      <v-subheader class="sn-subtitle-2">
        FILTER
      </v-subheader>
      <sn-btn
        v-if="!hideClearAll"
        class="mr-4"
        type="text"
        size="large"
        text="Clear all"
        data-cy="clear-all-btn"
        @click="$emit('filters:clear')"
      />
    </div>

    <div
      v-if="!hideSearch"
      class="d-flex justify-center px-4"
    >
      <sn-search
        v-model="search"
        width="100%"
      />
    </div>

    <div
      v-if="!visibleFilterOptions.length"
      class="d-flex justify-center"
    >
      <span>No matches found</span>
    </div>

    <v-list-item-group
      v-if="areFilterOptions"
      class="overflow-y-auto"
      :style="`max-height: ${maxHeight}`"
      multiple
    >
      <v-list-item
        v-for="filter in visibleFilterOptions"
        :key="filter.value"
        :value="filter.value"
        :ripple="false"
        class="filter-options__items"
        :data-cy="`filter-option-${filter.text}`"
        @change="$emit('filters:change', filter.value)"
      >
        <template #default>
          <v-list-item-action class="mr-3">
            <v-icon
              v-if="singleSelect"
              :color="filter.active ? 'snBrand03' : 'snPrimary03'"
            >
              {{ filter.active ? '$snRadioSelected' : '$snRadio' }}
            </v-icon>
            <v-icon
              v-else
              :color="filter.active ? 'snBrand03' : 'snPrimary03'"
            >
              {{ filter.active ? '$snCheckBoxSelected' : '$snCheckBox' }}
            </v-icon>
          </v-list-item-action>

          <v-list-item-content>
            <v-list-item-title class="sn-body-1">
              {{ filter.text }}
            </v-list-item-title>
          </v-list-item-content>
        </template>
      </v-list-item>
      <sn-infinite-loader
        v-if="dynamic"
        :has-next-page="hasNextPage"
        @load-more="$emit('filters:load-more')"
      />
    </v-list-item-group>
  </div>
</template>

<script>
import SnBtn from '~/components/snui/v2/snBtn/snBtn'
import SnSearch from '~/components/snui/v2/snSearch/snSearch'
import SnInfiniteLoader from '~/components/snui/v2/snInfiniteLoader/snInfiniteLoader'

export default {
  name: 'FilterOptions',
  components: {
    SnBtn,
    SnSearch,
    SnInfiniteLoader
  },
  props: {
    hideSearch: {
      type: Boolean,
      required: false,
      default: false
    },
    filterOptions: {
      type: [Array, Object],
      required: true
    },
    hideClearAll: {
      type: Boolean,
      required: false,
      default: false
    },
    maxHeight: {
      type: String,
      required: true
    },
    singleSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    dynamic: {
      type: Boolean,
      required: false,
      default: false
    },
    hasNextPage: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data () {
    return {
      search: ''
    }
  },
  computed: {
    rawFilters () {
      return this.filterOptions.nodes ?? this.filterOptions
    },
    areFilterOptions () {
      return this.filterOptions && this.rawFilters.length > 0
    },
    visibleFilterOptions () {
      const filters = this.filterOptions.nodes ?? this.filterOptions

      if (this.search) {
        return filters.filter(f => f.text.toUpperCase().includes(this.search.toUpperCase()))
      }

      return filters
    }
  },
  watch: {
    search () {
      if (this.dynamic) {
        this.$emit('filters:search', this.search)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep.filter-options__items.v-list-item--active {
  color: #fff;
}
</style>
